<!--购买渠道下拉框-->
<script>
import api from "@/api/projectApi";

export default {
  name: 'buyShopSelect',
  props: ['buyShopId'],
  mounted() {
    this.loadData()
  },
  data() {
    return {
      options: []
    }
  },
  methods: {
    changeSelect() {
      this.$emit('update:buyShopId', this.buyShopId)
    },

    clear() {
      this.$emit('update:buyShopId', null)
    },

    loadData() {
      this.$http.post(api.basBuyShop.getPromptListUrl, {}).then(res => {
        this.options = res.data.data
      })
    }
  }
}
</script>

<template>
  <div>
    <el-select v-model="buyShopId" @change="changeSelect" @clear="clear" filterable :clearable="true">
      <el-option v-for="item in options"
                 :key="item.id"
                 :label="item.shopName"
                 :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<style scoped lang="scss">

</style>
